const data = [
  {
    id: 1,
    name: "trabalhista",
  },
  {
    id: 2,
    name: "garantia real",
  },
  {
    id: 3,
    name: "quirografário",
  },
  {
    id: 4,
    name: "ME e EPP",
  },
  
];

export default [...data];
